/*eslint no-shadow:0*/
// Ignoring ESLint issue as this file will be deleted in 2.0
define('glu/host',['require','./glu','marionette','./locale','./util','./$','./promise','./http','./log','./core/internal/baseLayout'],function(require) {
    'use strict';

    var Glu = require('./glu'),
        Marionette = require('marionette'),
        locale = require('./locale'),
        util = require('./util'),
        $ = require('./$'),
        Promise = require('./promise'),
        http = require('./http'),
        log = require('./log'),
        BaseLayout = require('./core/internal/baseLayout');

    Glu.Host = function(guests) {
        var app = new Marionette.Application();

        // Place-holder for localisation (i18n) strings
        // TODO Move to Glu.locale
        window.Bottomline = window.Bottomline || {};
        window.Bottomline.i18n = Glu.i18n = {};

        // Override default renderer, in order to support Handlebars with runtime localisation support
        // TODO Once moved to Glu.locale, shouldn't need this anymore
        Marionette.Renderer.render = function(template, data) {
            return template(util.extend(data, {
                i18n: Glu.i18n
            }));
        };

        function setCookieClass() {
            var cookieEnabled = navigator.cookieEnabled || ('cookie' in document && (document.cookie.length > 0 || (document.cookie = 'test').indexOf.call(document.cookie, 'test') > -1));
            document.documentElement.className += cookieEnabled ? ' cookies' : ' no-cookies';
        }

        function run(Router, Controller, options) {
            // Steps to perform after application is started
            app.addInitializer(function(options) {
                var baseLayout = new BaseLayout(options),
                    appRoot = options.appRoot;
                baseLayout.render(options);

                new Router({
                    controller: new Controller(options)
                });

                if (options.user.isAuthenticated) {
                    return Glu.history.start({
                        pushState: true,
                        root: appRoot || '/'
                    });
                }
            });

            app.start(options);
        }

        Glu.host = {
            guests: guests,

            start: function() {
                var origin = window.location.origin || window.location.protocol + '//' + window.location.host;
                var url = window.location.href.replace(origin, '')
                    .replace('#', '/')
                    .replace(/\/\//g, '/');

                var module;
                util.each(this.guests, function(route, name) {
                    if (url.indexOf(route) > -1) {
                        module = name + '/main';
                    }
                });

                module = module || 'app/main'; // TODO work out what the actual default is

                require([module]);
            },

            loadGuest: function(Router, Controller, options) {
                options = options || {};
                var promises = options.promises || [],
                    afterAuthPromises = options.afterAuthPromises || [],
                    url = window.location.href,
                    notAuthorised = options.notAuthorised || [],
                    fadeOutMs = options.fadeOutMs || 200;

                // Push the promises into the host
                this.promises = promises;

                setCookieClass();

                // Ensure IE8 or above
                if (document.documentElement.className.indexOf('lt-ie8') > -1) {
                    throw new Error(locale.get('iE7Error'));
                }

                var $content = $('.glu-content'),
                    $loader = $('.glu-loader');

                function startApp(authenticated) {
                    if (options.progressBar !== false) {
                        Glu.host.updateProgressBar('Rendering');
                    }

                    $content.show();

                    $loader.fadeOut(fadeOutMs, function() {
                        run(Router, Controller, util.extend(options, {
                            user: {
                                isAuthenticated: authenticated
                            },
                            brandMode: options.brandMode || false
                        }));
                    });
                }

                function isANotAuthorizedUrl(url) {
                    return util.some(notAuthorised, function(regex) {
                        return url.match(regex);
                    });
                }

                Promise.all(promises)
                    .then(function() {
                        // Make an initial call the the ping URL to ensure we're logged in
                        return new Promise(function(resolve, reject) {
                            if (options.authTest) {
                                // The object from authentication is passed implicitly to startApp.
                                // Now pass it through for afterAuthPromises and resolve the
                                // authenticated object.  It still gets passed to startApp via the then
                                // statement.
                                http.get(options.authTest, function(authenticated) {

                                    // after auth promises should be functions that return promises
                                    // not promises themselves, the idea being that these are services
                                    // you want to hit only after you know the user is authenticated,
                                    // but before you display the nav (locale, user info, etc)
                                    var afterAuthPromiseList = [];
                                    util.each(afterAuthPromises, function(promise) {
                                        afterAuthPromiseList.push(promise());
                                    });

                                    // you would also need to implement this in your login success
                                    // response as this path isn't followed from loginNav
                                    Promise.all(afterAuthPromiseList).then(function() {
                                        resolve(true);
                                    });

                                }, reject);
                            } else {
                                resolve(false);
                            }
                        });
                    })
                    .then(startApp)
                    .then(null, function(err) {
                        if (err.status === 401) {
                            var isUserConsideredAuthenticated = isANotAuthorizedUrl(url);
                            startApp(isUserConsideredAuthenticated);
                        } else {
                            log.error(err);
                            Glu.host.updateProgressBar(err, true);
                        }
                    });
            },

            updateProgressBar: function(message, failure) {
                var processedRequests = 0, // Perform pre-start operations
                    $progressBar = $('.glu-progress .progress-bar'),
                    $progressMessage = $('.glu-progress-message');

                if (!failure && this.promises && this.promises.length) {
                    var percent = Math.ceil((++processedRequests / this.promises.length) * 100);
                    $progressBar.width(percent + '%');
                }

                if (message) {
                    $progressMessage.text(message);
                }
            }
        };

        return Glu.host;
    };

    return Glu.Host;
});

